import {
  Input,
  Text,
  Checkbox,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Spacer,
  AccordionPanel,
  Tooltip
} from "@chakra-ui/react";
import Modal from "../../../components/Modal";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Role} from "../Roles";
import {getAxiosInstance} from "../../../utils/axiosInstance";
import { toast } from "react-toastify";

interface EditRoleModalProps {
  open: boolean;
  onClose: () => void;
  role: Role | null;
}

interface EnitiyPermissions {
  entity: string
  permissions: string[]
}

const EditRoleModal = (props: EditRoleModalProps) => {
  const {
    open,
    onClose,
    role
  } = props;

  const {t} = useTranslation("translations");
  const permissionTranslations= useTranslation("permissions");

  const [roleName, setRoleName] = useState<string>("");
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);
  const [allPermissions, setAllPermissions] = useState<EnitiyPermissions[]>([]);
  const [roleUpdateLoading, setRoleUpdateLoading] = useState<boolean>(false);

  const fetchEntitiesPermissions = async () => {
    try {
      const res = await getAxiosInstance().get('/Role/permissions');
      setAllPermissions(res.data);
    } catch (e) {
    }
  }

  const checkIfAllPermissions = (e: EnitiyPermissions): boolean => {
    let checkAll = true;
    for (const p of e.permissions) {
      if (selectedPermissions.findIndex(x => x === p) === -1)
        checkAll = false;
    }
    return checkAll;
  }

  const handleCheckAlll = (e: EnitiyPermissions) => {
    const check = checkIfAllPermissions(e);

    if (check) {
      let tmp = [...selectedPermissions];
      for (const p of e.permissions) {
        tmp.splice(tmp.findIndex(x => x === p), 1);
      }
      setSelectedPermissions([...tmp]);
    } else {
      setSelectedPermissions([...new Set([...selectedPermissions, ...e.permissions])]);
    }
  }

  const checkPermission = (e: string) => {
    const index = selectedPermissions.findIndex(x => x === e);
    
    if(index !== -1) {
      let tmp = [...selectedPermissions];
      tmp.splice(index, 1);
      setSelectedPermissions([...tmp]);
    } else {
      setSelectedPermissions([...selectedPermissions, e]);
    }
  }
  
  const updateRole = async () => {
    setRoleUpdateLoading(true);
    try {
      if(role) {
        await getAxiosInstance().put('/Role', {
          id: role.id,
          role: roleName,
          permissions: selectedPermissions,
        });
        toast.success(t("UPDATE_ROLE_SUCCESSFULLY"), { position: "bottom-right" });
        onClose();
      }

    } catch (e) {
      toast.error(t("UPDATE_ROLE_FAILED"), { position: "bottom-right" });
    } finally {
      setRoleUpdateLoading(false);
    }
  }
  
  useEffect(() => {
    if (role) {
      setRoleName(role.role);
      setSelectedPermissions(role.originalPermissions);
    }
  }, [role]);

  useEffect(() => {
    fetchEntitiesPermissions();
  }, []);

  return (
    <Modal
      header={t("EDIT_ROLE_MODAL_TITLE")}
      isOpen={open}
      onClose={onClose}
      secondaryActionName={t("Save")}
      secondaryActionEnabled={roleName.length > 3}
      secondaryAction={() => updateRole()}
      secondaryActionLoading={roleUpdateLoading}
    >
      <Input
        value={roleName}
        onChange={(e) => setRoleName(e.target.value)}
        placeholder={t("EDIT_ROLE_MODAL_INPUT_PLACE_HOLDER_TEXT")}
      />
      <div className="mt-5">
        <Text fontSize="xl" as="b">{t("PERMISSIONS")}</Text>
      </div>
      <Accordion className="mt-5">
        {
          allPermissions.map((p) => (
            <AccordionItem>
              <AccordionButton>
                <Checkbox
                  onChange={() => handleCheckAlll(p)}
                  isChecked={checkIfAllPermissions(p)}
                />
                <Text className="ml-2" fontSize="md" as="b">
                  {permissionTranslations.t(p.entity)}
                </Text>
                <Spacer/>
                <AccordionIcon/>
              </AccordionButton>
              <AccordionPanel>
                {
                  p.permissions.map((c) => (
                    <Tooltip label={permissionTranslations.t(c + "_TOOLTIP")} aria-label={permissionTranslations.t(c + "_TOOLTIP")}>
                      <div className="my-2 ml-4">
                        <Checkbox
                          onChange={() => checkPermission(c)}
                          isChecked={selectedPermissions.findIndex(x => x === c) !== -1}
                        >
                          {permissionTranslations.t(c)}
                        </Checkbox>
                      </div>
                    </Tooltip>
                  ))
                }
              </AccordionPanel>
            </AccordionItem>
          ))
        }
      </Accordion>
    </Modal>
  )
}

export default EditRoleModal;